import {
  CmpSelectField,
  CmpInputFieldGroup,
  CmpInputField,
  CmpTypographyField,
  CmpStatus,
} from "../../../Component/Common/ToolBox/ToolBox";
import { hasValueInErrorMessage } from "../../../Utility/Utilitys";
import Grid from "@mui/material/Grid";

export default function WmsSalesFooter({
  Salesman,
  sFooterObj,
  fonChangeInputDiscount,
  fonChangeRounding,
  fOpenDiscountPercentageModal,
  fonClickInputFocusRounding,
  fonClickInputBlurRounding,
  sErrorMsg,
  vRdxSalesQuotationHead,
  fonChangeSelectSalesMan,
  fonClickInputBlurDiscount,
  fonClickInputFocusDiscount,
  fonChangeInputFooter,
}) {
  return (
    <div className="Wms-sales-invoice-footer">
      <Grid
        container
        rowSpacing={{ xs: 0, sm: 0, md: 0 }}
        columnSpacing={{ xs: 0, sm: 0, md: 1 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
        justifyContent="space-between"
      >
        <Grid item xs={12} sm={12} md={5} lg={5}>
          <Grid
            container
            spacing={0}
            columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
            className={
              hasValueInErrorMessage(sErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            <Grid item xs={2} sm={2} md={2} lg={2}>
              <CmpTypographyField xcomponent={"span"} xText={"Sales Man"} />
            </Grid>
            <Grid item xs={10} sm={10} md={5} lg={5}>
              <CmpSelectField
                xtabIndex="201"
                xLabelText="A_Buyer"
                xValue={vRdxSalesQuotationHead.A_Buyer}
                xOnChange={(e) => {
                  fonChangeSelectSalesMan(e, Salesman);
                }}
                xName={"A_Buyer"}
                xData={Salesman}
                xValueMember={""}
                xDispalyMember={""}
                xError={sErrorMsg.A_Buyer === "" ? false : true}
                xErrorMessage={sErrorMsg.A_Buyer}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={5} lg={5} className="text-center">
              <CmpStatus xStatus={vRdxSalesQuotationHead.A_DocStat} />
            </Grid>

            <Grid item xs={2} sm={4} md={2} lg={2}>
              <CmpTypographyField xcomponent={"span"} xText={"Narration"} />
            </Grid>
            <Grid item xs={10} sm={8} md={10} lg={10}>
              <CmpInputField
                xtabIndex="203"
                xValue={vRdxSalesQuotationHead.A_Narr}
                xType={"text"} // text/number/password
                xName={"A_Narr"}
                xReadOnly={false}
                xOnChange={(e) => {
                  fonChangeInputFooter(e);
                }}
                xError={sErrorMsg.A_Narr === "" ? false : true}
                xErrorMessage={sErrorMsg.A_Narr}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <Grid
            container
            spacing={0}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(sErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            <Grid item xs={4} sm={4} md={4} lg={6}>
              <CmpTypographyField xcomponent={"span"} xText={"Gross Amount"} />
            </Grid>
            <Grid item xs={8} sm={8} md={8} lg={6}>
              <CmpInputField
                xValue={sFooterObj.A_GrossAmt}
                xType={"text"} // text/number/password
                xName={"A_GrossAmt"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpTypographyField xcomponent={"span"} xText={"Discount"} />
            </Grid>
            <Grid
              item
              xs={2}
              sm={2}
              md={2}
              lg={2}
              onDoubleClick={fOpenDiscountPercentageModal}
            >
              <CmpInputField
                xValue={vRdxSalesQuotationHead.A_DiscPerc}
                xType={"text"} // text/number/password
                xName={"A_DiscPerc"}
                xReadOnly={true}
                xOnChange={(e) => fonChangeInputDiscount(e)}
                xError={sErrorMsg.A_DiscPerc === "" ? false : true}
                xErrorMessage={sErrorMsg.A_DiscPerc}
                xTextAlign="end"
              />
            </Grid>

            <Grid item xs={2} sm={2} md={2} lg={2}>
              <CmpInputField
                xValue={sFooterObj.A_TDiscAmt}
                xType={"text"} // text/number/password
                xName={"A_TDiscAmt"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpInputField
                xValue={sFooterObj.A_LDiscAmt}
                xType={"text"} // text/number/password
                xName={"A_LDiscAmt"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>

            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpTypographyField xcomponent={"span"} xText={"FOC & Excise"} />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpInputField
                xValue={sFooterObj.A_FocAmt}
                xType={"text"} // text/number/password
                xName={"A_FocAmt"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpInputField
                xValue={sFooterObj.A_NetExcise}
                xType={"text"} // text/number/password
                xName={"A_NetExcise"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpTypographyField
                xcomponent={"span"}
                xText={"Tax ,Cess & AddCess"}
              />
            </Grid>
            <Grid item xs={3} sm={3} md={2.5} lg={2.5}>
              <CmpInputField
                xValue={sFooterObj.A_Tax}
                xType={"text"} // text/number/password
                xName={"A_Tax"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={3} sm={3} md={2.5} lg={2.5}>
              <CmpInputField
                xValue={sFooterObj.A_Tax2}
                xType={"text"} // text/number/password
                xName={"A_Tax2"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={2} sm={2} md={3} lg={3}>
              <CmpInputField
                xValue={sFooterObj.A_AddCess}
                xType={"text"} // text/number/password
                xName={"A_AddCess"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpTypographyField
                xcomponent={"span"}
                xText={"Rounding & Net_Amt"}
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpInputField
                xtabIndex="205"
                xValue={vRdxSalesQuotationHead.A_Rounding}
                xType={"number"} // text/number/password
                xName={"A_Rounding"}
                xReadOnly={false}
                xOnChange={(e) => fonChangeRounding(e)}
                xError={sErrorMsg.A_Rounding === "" ? false : true}
                xErrorMessage={sErrorMsg.A_Rounding}
                xonFocus={(e) => {
                  fonClickInputFocusRounding(e);
                }}
                xonBlur={(e) => {
                  fonClickInputBlurRounding(e);
                }}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpInputField
                xValue={sFooterObj.A_LandVal}
                xType={"text"} // text/number/password
                xName={"A_LandVal"}
                xReadOnly={true}
                xOnChange={""}
                xError={sErrorMsg.A_Rounding === "" ? false : true}
                xErrorMessage={sErrorMsg.A_Rounding}
                xTextAlign="end"
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
